/* eslint-disable no-promise-executor-return */
import { put, all, takeLatest } from 'redux-saga/effects';
import { incrementSuccess } from './actions';
import { COUNTER_TYPES } from './types';

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export function* incrementAsync() {
  yield delay(2000);
  yield put(incrementSuccess());
}

export default all([
  takeLatest(COUNTER_TYPES.INCREMENT_REQUEST, incrementAsync),
]);
